import React, { useEffect } from "react";
import { Link } from "react-router-dom";
const getDate = () => {
  document.getElementById("year").innerHTML = new Date().getFullYear();
};
const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    getDate();
  }, []);
  return (
    <section className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="row pb-5">
            <div className="col-lg-3 mt-3 mb-3">
              <h4>About Us</h4>
              <p>We offer Piano lessons in Dallas, TX and in Washington, DC.</p>
            </div>
            <div className="col-lg-3 offset-lg-1 mt-3 mb-3">
              <h4>Quick Links</h4>
              <ul>
                <li>
                  <Link to="/" onClick={scrollToTop}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" onClick={scrollToTop}>
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/piano-camp" onClick={scrollToTop}>
                    Piano Camp
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={scrollToTop}>
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 mt-3 mb-3">
              <h4>Contact</h4>
              <ul>
                <li>
                  <i className="fa fa-map-marker"></i>&nbsp;&nbsp;Dallas, TX.
                </li>
                <li>
                  <a href="mailto:info@charlottebay.com">
                    <i className="fa fa-envelope"></i>
                    &nbsp;&nbsp;info@charlottebay.com
                  </a>
                </li>
                <li>
                  <a href="tel:+1 (123)456-7890">
                    <i className="fa fa-phone"></i>&nbsp;&nbsp;+1 (123)456-7890
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 mt-3 mb-3">
              <h4>Let's Connect</h4>
              <ul className="footer-socials">
                <li>
                  <a href="/" target="_blank" rel="noreferrer">
                    <i className="fa fa-facebook fa-2x"></i>
                  </a>
                </li>
                <li>
                  <a href="/">
                    <i className="fa fa-linkedin fa-2x"></i>
                  </a>
                </li>
                <li>
                  <a href="/">
                    <i className="fa fa-twitter fa-2x"></i>
                  </a>
                </li>
                <li>
                  <a href="/">
                    <i className="fa fa-instagram fa-2x"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <p className="text-center copyright">
            © <span id="year"></span> Charlotte Bay. All Rights Reserved |
            Developed by{" "}
            <a
              rel="noreferrer"
              target="_blank"
              href="https://justicetowett.netlify.app"
            >
              Justice Towett
            </a>{" "}
            | Designed by{" "}
            <a
              rel="noreferrer"
              target="_blank"
              href="https://joan.smodern.co.ke"
            >
              Joan Gichuhi
            </a>
            {/* .
            <br />
            Credit to{" "}
            <a rel="noreferrer" target="_blank" href="#">
              Edith Nekesa
            </a>{" "}
            for the Upcoming Events section */}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Footer;
